module.exports = __webpack_public_path__ + "img/DE01018.30c52249.png";